import { MapStringTo } from "../base-types";
import { RealtimeRequest } from "../models/notifications/realtime-request";

export class NotificationMapper {
    static mapParameters(request: RealtimeRequest): MapStringTo<unknown> {
        const parameters = {
            title: request.title,
            options: request.options,
            extra: {
                level: request.notificationLevel,
                link: request.link,
            },
        };

        return parameters;
    }
}
